import React from "react";
import { Trans, useTranslation } from "react-i18next";
import { Link } from "components/common";
import IlluminateRoutes from "illuminate/Routes";
const IlluminateCSVFileAdapterDocumentation = () => {
  const { t } = useTranslation("enterprise_lookup");
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement("p", null, t("illuminate_csv_documentation.description")), /* @__PURE__ */ React.createElement("p", null, /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "illuminate_csv_documentation.customize",
      components: { customizeLink: /* @__PURE__ */ React.createElement(Link, { to: IlluminateRoutes.CUSTOMIZATION }) }
    }
  )), /* @__PURE__ */ React.createElement("p", null, t("illuminate_csv_documentation.precedence")));
};
export default IlluminateCSVFileAdapterDocumentation;
